(ns common.toaster-bus.db
  " Toaster-bus is a collection of events for managing a message toaster that
  appears at the top of the page

  Toaster-bus.db/add
  -----------------
  A simple event to allow showing a toaster of a type at the top of the screen

  There are 3 types of toaster:
  - :info
  - :success
  - :error

  The event `:toaster-bus/add` adds or replaces the latest toaster with a new one.
  The `:toaster-bus/add` event accepts a map with the following format:

  | key             | description                                                    |
  |-----------------+----------------------------------------------------------------|
  | `:id`           | A unique identifier for that message                           |
  | `:type`         | one of :info, :success,  :error dictates the visual appearance |
  | `:message`      | A string of the message that will be displayed                 |
  | `:full-message` | A string                                                       |

  The toaster stores extra ui information with the message:
  | key            | description                                                                |
  |----------------+----------------------------------------------------------------------------|
  | `:message`     | The message map with the keys described above                              |
  | `:ui`          | UI state holding map.                                                      |

  The `:expanded` key indicates whether the `:full-message` is being displayed or not.
  When the toaster is expanded *all* other messages will be ignored.
  "
  (:require [common.db.effects.clipboard]
            [re-frame.core :as rf]))

(defn message-id
  "random enough for our purposes"
  []
  (-> (js/Math.random)
      (* 100000000000)
      (js/Math.floor)))

;; The public API
(rf/reg-event-fx :toaster-bus/add
  (fn [{:keys [db]} [_ message]]
    (let [expanded (get-in db [:toaster-bus/bus :ui :expanded])]
      ;; If current message is expanded, new message is ignored.
      (when-not expanded
        {:dispatch [::new-message message]}))))

(rf/reg-event-fx ::new-message
  (fn [{:keys [db]} [_ new-message]]
    (let [message (if (:id new-message)
                    new-message
                    (assoc new-message :id (message-id)))]
      {:db (assoc db :toaster-bus/bus {:message message
                                       :ui {:open true
                                            :expanded false}})})))

(rf/reg-event-fx ::close
  (fn [{:keys [db]} [_ id]]
    (when (= id (get-in db [:toaster-bus/bus :message :id]))
      {:db (assoc-in db [:toaster-bus/bus :ui :open] false)})))

(rf/reg-event-fx ::closed
  (fn [{:keys [db]} [_ id]]
    (when (= id (get-in db [:toaster-bus/bus :message :id]))
      {:db (dissoc db :toaster-bus/bus)})))

(rf/reg-event-fx ::full-message-toggle
  (fn [{:keys [db]} _]
    {:db (update-in db [:toaster-bus/bus :ui :expanded] not)}))

(rf/reg-event-fx ::copy-full-message
  (fn [{:keys [db]} [_ set-status]]
    (let [text (get-in db [:toaster-bus/bus :message :full-message])]
      {:content->clipboard {:content text
                            :success #(set-status :success)
                            :error #(set-status :error)}})))

(rf/reg-sub ::message
  (fn [db]
    (get-in db [:toaster-bus/bus :message])))

(rf/reg-sub ::open?
  (fn [db]
    (get-in db [:toaster-bus/bus :ui :open])))

(rf/reg-sub ::expanded?
  (fn [db]
    (get-in db [:toaster-bus/bus :ui :expanded])))

(comment
  (rf/dispatch [:toaster-bus/add {:type (rand-nth [:info :error])
                                  :message (str "Foobar " (rand-int 100))
                                  :full-message (apply str (interpose " " (repeat 50 "Foo")))}]))
